import React, { useEffect, useState } from 'react';
import TextInput from '../../../components/library/inputs/text/TextInput';

interface DefaultSettingProps {
  content: string;
  editMode?: boolean;
  onChange: (content: string) => void;
}
export const DefaultSetting: React.FC<DefaultSettingProps> = ({ content, editMode = false, onChange }) => {
  const [contentValue, setContentValue] = useState(content);

  useEffect(() => {
    setContentValue(content);
  }, [editMode]);

  return (
    <div className="setting-content">
      {!editMode && (
        <div className="d-flex align-items-center">
          <div className="setting-block flex-1">{content}</div>
        </div>
      )}
      {editMode && (
        <div className="d-flex align-items-center">
          <div className="flex-1">
            <TextInput
              value={contentValue}
              onChange={(e) => {
                setContentValue(e.target.value);
                onChange(e.target.value);
              }}
              rest={{
                rows: 10,
                as: 'textarea',
              }}
            ></TextInput>
          </div>
        </div>
      )}
    </div>
  );
};

export default DefaultSetting;
